module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/14mill-inactive-5aa55b1dafbe4848a20ec15651c1739e.png";